import { baseApi } from "./baseApi";

const SHIPMENT_MESSAGES_BASE_URL = "/sms-logs";

export const shipmentMessagesApi = baseApi.injectEndpoints({
  tagTypes: ["ShipmentMessages"],

  endpoints: (build) => ({
    listShipmentMessages: build.query({
      query: (params) => ({
        url: SHIPMENT_MESSAGES_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "ShipmentMessages",
                id: _id,
              })),
              { type: "ShipmentMessages", id: "LIST" },
            ]
          : [{ type: "ShipmentMessages", id: "LIST" }],
    }),
    getShipmentMessagesByShipmentId: build.query({
      query: (shipmentId) => `${SHIPMENT_MESSAGES_BASE_URL}/${shipmentId}`,
      providesTags: (result, error, shipmentId) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "ShipmentMessages",
                id: _id,
              })),
              { type: "ShipmentMessages", id: "LIST" },
            ]
          : [{ type: "ShipmentMessages", id: "LIST" }],
    }),

  }),
  overrideExisting: false,
});

export const {
  useListShipmentMessagesQuery,
  useLazyListShipmentMessagesQuery,
  useGetShipmentMessagesByShipmentIdQuery,
} = shipmentMessagesApi;